export const AdminLogo = <img height={34} src="/assets/logo_admin.png" />;
